var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 251,
    viewBox: "0 0 576 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M486.266 250.292H436.682V84.9179L486.266 105.953V250.292Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 113.885L443.208 97.5245V93.8417L480.946 109.99V113.885Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 122.313L443.208 105.953V102.27L480.946 118.418V122.313Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 130.741L443.208 114.381V110.698L480.946 126.846V130.741Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 139.169L443.208 122.809V119.126L480.946 135.274V139.169Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 147.597L443.208 131.237V127.554L480.946 143.702V147.597Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 155.954L443.208 139.665V135.982L480.946 152.13V155.954Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 164.382L443.208 148.093V144.41L480.946 160.558V164.382Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 172.81L443.208 156.521V152.838L480.946 168.986V172.81Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 181.238L443.208 164.949V161.266L480.946 177.414V181.238Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 189.666L443.208 173.377V169.694L480.946 185.842V189.666Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 198.095L443.208 181.805V178.122L480.946 194.27V198.095Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 206.523L443.208 190.233V186.55L480.946 202.698V206.523Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 214.951L443.208 198.661V194.978L480.946 211.126V214.951Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 223.379L443.208 207.089V203.406L480.946 219.554V223.379Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 231.807L443.208 215.517V211.834L480.946 227.982V231.807Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 240.235L443.208 223.945V220.262L480.946 236.41V240.235Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M480.946 247.6H443.208V228.69L480.946 244.838V247.6Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M436.682 84.9179H426.041L408.946 99.0827V250.292H436.682V84.9179Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M409.513 85.4137H334.605V250.292H409.513V85.4137Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M339.925 85.4137H334.605V250.292H339.925V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M349.998 85.4137H344.678V250.292H349.998V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M360 85.4137H354.68V250.292H360V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M370.002 85.4137H364.682V250.292H370.002V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M380.075 85.4137H374.755V250.292H380.075V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M390.077 85.4137H384.757V250.292H390.077V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M400.15 85.4137H394.83V250.292H400.15V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.152 85.4137H404.832V250.292H410.152V85.4137Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.152 80.6685H334.605V85.4137H410.152V80.6685Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M392.772 74.8609H352.055V80.6685H392.772V74.8609Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 81.235H283.886V250.292H311.622V81.235Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 81.235H283.886V83.3598H311.622V81.235Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 85.4137H283.886V87.5384H311.622V85.4137Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 89.6631H283.886V91.7878H311.622V89.6631Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 93.8417H283.886V95.9664H311.622V93.8417Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 98.0203H283.886V100.145H311.622V98.0203Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 102.27H283.886V104.394H311.622V102.27Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 106.448H283.886V108.573H311.622V106.448Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 110.698H283.886V112.823H311.622V110.698Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 114.876H283.886V117.001H311.622V114.876Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 119.126H283.886V121.251H311.622V119.126Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 123.304H283.886V125.429H311.622V123.304Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 127.554H283.886V129.679H311.622V127.554Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 131.733H283.886V133.857H311.622V131.733Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 135.982H283.886V138.107H311.622V135.982Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 140.161H283.886V142.285H311.622V140.161Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 144.41H283.886V146.535H311.622V144.41Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 148.589H283.886V150.713H311.622V148.589Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 152.838H283.886V154.963H311.622V152.838Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 157.017H283.886V159.141H311.622V157.017Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 161.266H283.886V163.391H311.622V161.266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 165.445H283.886V167.569H311.622V165.445Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 169.694H283.886V171.819H311.622V169.694Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 173.873H283.886V175.997H311.622V173.873Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 178.122H283.886V180.247H311.622V178.122Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 182.301H283.886V184.425H311.622V182.301Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 186.55H283.886V188.675H311.622V186.55Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 190.729H283.886V192.854H311.622V190.729Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 194.978H283.886V197.103H311.622V194.978Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 199.157H283.886V201.282H311.622V199.157Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 203.406H283.886V205.531H311.622V203.406Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 207.585H283.886V209.71H311.622V207.585Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 211.834H283.886V213.959H311.622V211.834Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 216.013H283.886V218.138H311.622V216.013Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 220.262H283.886V222.387H311.622V220.262Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 224.441H283.886V226.566H311.622V224.441Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 228.69H283.886V230.815H311.622V228.69Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 232.869H283.886V234.994H311.622V232.869Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 237.119H283.886V239.243H311.622V237.119Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 241.297H283.886V243.422H311.622V241.297Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 245.547H283.886V247.671H311.622V245.547Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.622 75.4275H283.886V81.2351H311.622V75.4275Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 47.5229H310.416V250.292H338.152V47.5229Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 81.235H310.416V83.3598H338.152V81.235Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 85.4137H310.416V87.5384H338.152V85.4137Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 72.807H310.416V74.9317H338.152V72.807Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 76.9856H310.416V79.1103H338.152V76.9856Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 64.379H310.416V66.5037H338.152V64.379Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 68.5576H310.416V70.6823H338.152V68.5576Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 55.9509H310.416V58.0756H338.152V55.9509Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 60.1295H310.416V62.2542H338.152V60.1295Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 47.5229H310.416V49.6476H338.152V47.5229Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 51.7015H310.416V53.8262H338.152V51.7015Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 89.6631H310.416V91.7878H338.152V89.6631Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 93.8417H310.416V95.9664H338.152V93.8417Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 98.0203H310.416V100.145H338.152V98.0203Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 102.27H310.416V104.394H338.152V102.27Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 106.448H310.416V108.573H338.152V106.448Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 110.698H310.416V112.823H338.152V110.698Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 114.876H310.416V117.001H338.152V114.876Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 119.126H310.416V121.251H338.152V119.126Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 123.304H310.416V125.429H338.152V123.304Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 127.554H310.416V129.679H338.152V127.554Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 131.732H310.416V133.857H338.152V131.732Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 135.982H310.416V138.107H338.152V135.982Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 140.161H310.416V142.285H338.152V140.161Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 144.41H310.416V146.535H338.152V144.41Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 148.589H310.416V150.713H338.152V148.589Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 152.838H310.416V154.963H338.152V152.838Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 157.017H310.416V159.141H338.152V157.017Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 161.266H310.416V163.391H338.152V161.266Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 165.445H310.416V167.569H338.152V165.445Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 169.694H310.416V171.819H338.152V169.694Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 173.873H310.416V175.997H338.152V173.873Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 178.122H310.416V180.247H338.152V178.122Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 182.301H310.416V184.425H338.152V182.301Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 186.55H310.416V188.675H338.152V186.55Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 190.729H310.416V192.854H338.152V190.729Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 194.978H310.416V197.103H338.152V194.978Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 199.157H310.416V201.282H338.152V199.157Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 203.406H310.416V205.531H338.152V203.406Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 207.585H310.416V209.71H338.152V207.585Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 211.834H310.416V213.959H338.152V211.834Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 216.013H310.416V218.138H338.152V216.013Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 220.262H310.416V222.387H338.152V220.262Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 224.441H310.416V226.566H338.152V224.441Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 228.69H310.416V230.815H338.152V228.69Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 232.869H310.416V234.994H338.152V232.869Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 237.119H310.416V239.243H338.152V237.119Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 241.297H310.416V243.422H338.152V241.297Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 245.547H310.416V247.671H338.152V245.547Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 41.7153H310.416V47.5229H338.152V41.7153Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 142.285H310.416V148.589H338.152V142.285Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M338.152 41.7153H330.49V250.292H338.152V41.7153Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M310.416 81.235H302.755V250.292H310.416V81.235Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M296.654 108.573H226.002V250.221H296.654V108.573Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 115.868H231.677V130.883H290.979V115.868Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 133.716H231.677V148.73H290.979V133.716Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 151.492H231.677V166.507H290.979V151.492Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 169.34H231.677V184.355H290.979V169.34Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 187.188H231.677V202.202H290.979V187.188Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 205.177H231.677V250.292H290.979V205.177Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 115.868H265.584V130.883H290.979V115.868Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 133.716H265.584V148.73H290.979V133.716Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 151.492H265.584V166.507H290.979V151.492Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 169.34H265.584V184.355H290.979V169.34Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 187.188H265.584V202.202H290.979V187.188Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.979 205.177H265.584V250.292H290.979V205.177Z",
    fill: "#D3D3D3"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M243.169 81.0934H188.264V250.292H243.169V81.0934Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M233.167 68.8409H198.266V82.2266H233.167V68.8409Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M238.132 88.0341H193.23V250.292H238.132V88.0341Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M228.13 85.5553H226.357V250.292H228.13V85.5553Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M205.005 85.5553H203.232V250.292H205.005V85.5553Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M216.426 85.5553H214.652V250.292H216.426V85.5553Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M193.017 250.292H143.078V128.9L168.047 105.953L193.017 128.9V250.292Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.173 250.292H144.851V129.891L168.047 108.431L191.173 129.891V250.292Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.598 132.37H144.426V134.424H191.598V132.37Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.669 144.127H144.497V146.181H191.669V144.127Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.598 155.671H144.426V157.725H191.598V155.671Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.598 167.357H144.426V169.411H191.598V167.357Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.669 178.405H144.497V180.459H191.669V178.405Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.598 189.879H144.426V191.933H191.598V189.879Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.598 201.352H144.426V203.406H191.598V201.352Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.669 212.826H144.497V214.88H191.669V212.826Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.243 224.229H144.071V226.282H191.243V224.229Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M191.243 235.702H144.071V237.756H191.243V235.702Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M144.567 102.27H89.734V250.292H144.567V102.27Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M141.943 104.324H92.5005V250.221H141.943V104.324Z",
    fill: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M109.525 102.553H107.752V250.292H109.525V102.553Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M126.621 103.261H124.847V250.292H126.621V103.261Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M91.4529 119.502L91.4529 121.131L143.662 121.131L143.662 119.502L91.4529 119.502Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.2419 137.336L90.2419 138.965L142.451 138.965L142.451 137.336L90.2419 137.336Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.2817 155.144L90.2817 156.773L142.491 156.773L142.491 155.144L90.2817 155.144Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.6025 172.95V174.579H142.811V172.95H90.6025Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.2903 190.76L90.2903 192.389L142.499 192.389L142.499 190.76L90.2903 190.76Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.6111 208.566V210.194H142.82V208.566H90.6111Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.6509 226.374L90.6509 228.003L142.86 228.003L142.86 226.374L90.6509 226.374Z",
    fill: "#E6E6E6"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.042 248.946C107.965 248.096 108.319 246.821 107.965 245.547C107.468 243.776 107.326 241.935 107.397 240.022C107.965 232.09 114.278 225.645 122.152 224.937C123.925 224.795 125.628 224.866 127.188 225.22C127.968 225.362 128.749 224.795 128.749 223.945C128.749 217.359 134.069 211.976 140.737 211.976C143.574 211.976 146.199 212.968 148.256 214.597C148.966 215.163 149.959 215.092 150.526 214.384C152.512 211.834 156.414 210.914 160.102 213.605C161.876 215.871 162.231 218.209 161.663 220.192C162.16 220.192 162.585 220.192 163.082 220.192C174.573 220.192 184.859 225.078 192.095 232.94C192.733 232.586 193.513 232.373 194.365 232.373C197.06 232.373 199.259 234.569 199.259 237.26C199.259 237.756 199.188 238.181 199.046 238.677C199.401 238.677 199.756 238.677 200.181 238.677C209.829 238.677 218.483 243.209 223.945 250.363H158.329H133.501H105.695C106.12 249.796 106.617 249.371 107.042 248.946Z",
    fill: "#0E66F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M494.92 107.227L471.866 171.04C465.411 188.887 469.738 207.727 483.996 223.52C490.735 231.028 507.334 231.028 514.144 223.52C528.331 207.727 532.729 188.958 526.274 171.04L503.22 107.227C502.156 104.324 495.913 104.324 494.92 107.227Z",
    fill: "#D4E8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.169 161.762H497.899V250.292H500.169V161.762Z",
    fill: "#72B3FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M536.418 145.543L520.244 190.304C515.705 202.84 518.755 216.013 528.757 227.062C533.509 232.302 545.143 232.302 549.896 227.062C559.898 216.013 562.948 202.769 558.408 190.304L542.235 145.543C541.454 143.56 537.127 143.56 536.418 145.543Z",
    fill: "#0E66F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M540.461 197.174H538.191V250.292H540.461V197.174Z",
    fill: "#D4E8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0808 107.227L27.0266 171.04C20.5714 188.887 24.8985 207.727 39.1566 223.52C45.8955 231.028 62.4945 231.028 69.3044 223.52C83.4916 207.727 87.8896 188.958 81.4345 171.04L58.3803 107.227C57.3162 104.324 51.0739 104.324 50.0808 107.227Z",
    fill: "#D4E8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.33 161.762H53.0601V250.292H55.33V161.762Z",
    fill: "#72B3FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2274 145.543L66.054 190.304C61.5141 202.84 64.5643 216.013 74.5663 227.062C79.319 232.302 90.9525 232.302 95.7052 227.062C105.707 216.013 108.757 202.769 104.218 190.304L88.0441 145.543C87.2639 143.56 82.9368 143.56 82.2274 145.543Z",
    fill: "#0E66F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2707 197.174H84.0007V250.292H86.2707V197.174Z",
    fill: "#D4E8FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7202 171.96L7.66109 205.46C4.25617 214.809 6.52612 224.653 14.0453 232.94C17.5921 236.906 26.3173 236.906 29.864 232.94C37.3123 224.653 39.5823 214.809 36.2483 205.46L24.1892 171.96C23.4798 170.402 20.2168 170.402 19.7202 171.96Z",
    fill: "#2F3B49"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6995 210.56H20.9971V250.292H22.6995V210.56Z",
    fill: "#D4E8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5123 55.3135C78.0296 55.3135 75.7596 56.2342 73.9862 57.7215C73.3478 49.2226 66.2542 42.5652 57.6 42.5652C50.3645 42.5652 44.1931 47.2396 42.065 53.7554C40.93 53.3304 39.7241 53.118 38.4473 53.118C33.1271 53.118 28.7291 56.8008 27.5941 61.7585C27.5232 61.7585 27.3813 61.7585 27.3103 61.7585C23.5507 61.7585 20.5005 64.8039 20.5005 68.5576C20.5005 72.1696 23.3379 75.1442 26.9557 75.2858H34.8296H40.6463H52.3507H68.8079H80.5123C86.0453 75.2858 90.5143 70.8239 90.5143 65.2997C90.5143 59.7754 86.0453 55.3135 80.5123 55.3135Z",
    fill: "#D4E8FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.49 8.92381C143.716 8.92381 142.156 9.56123 140.95 10.6236C140.524 4.67438 135.559 0 129.529 0C124.493 0 120.165 3.2579 118.676 7.86146C117.895 7.57816 117.044 7.43651 116.122 7.43651C112.433 7.43651 109.312 10.057 108.532 13.4565C108.461 13.4565 108.39 13.4565 108.319 13.4565C105.694 13.4565 103.566 15.5813 103.566 18.2017C103.566 20.7514 105.553 22.8053 108.035 22.947H113.568H117.612H125.769H137.261H145.419C149.32 22.947 152.441 19.8307 152.441 15.9354C152.441 12.0401 149.391 8.92381 145.49 8.92381Z",
    fill: "#D4E8FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M362.553 248.946C361.631 248.096 361.277 246.821 361.631 245.547C362.128 243.776 362.27 241.935 362.199 240.022C361.631 232.09 355.318 225.645 347.444 224.937C345.671 224.795 343.968 224.866 342.408 225.22C341.627 225.362 340.847 224.795 340.847 223.945C340.847 217.359 335.527 211.976 328.859 211.976C326.021 211.976 323.397 212.968 321.34 214.597C320.63 215.163 319.637 215.092 319.07 214.384C317.083 211.834 313.182 210.914 309.493 213.605C307.72 215.871 307.365 218.209 307.933 220.192C307.436 220.192 307.011 220.192 306.514 220.192C295.022 220.192 284.737 225.078 277.501 232.94C276.863 232.586 276.082 232.373 275.231 232.373C272.536 232.373 270.337 234.569 270.337 237.26C270.337 237.756 270.408 238.181 270.549 238.677C270.195 238.677 269.84 238.677 269.414 238.677C259.767 238.677 251.113 243.209 245.651 250.363H311.267H336.094H363.901C363.476 249.796 362.979 249.371 362.553 248.946Z",
    fill: "#0E66F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M324.39 242.218C323.043 242.218 321.695 242.43 320.418 242.855C320.489 242.43 320.489 242.005 320.489 241.51C320.489 236.481 316.375 232.373 311.338 232.373C308.643 232.373 306.231 233.506 304.528 235.419C303.819 233.648 302.045 232.373 299.988 232.373C297.293 232.373 295.094 234.569 295.094 237.26C295.094 237.756 295.165 238.181 295.307 238.677C295.236 238.677 295.165 238.677 295.094 238.677C295.377 239.597 295.59 240.518 295.59 241.58C295.59 242.005 295.59 242.501 295.519 242.926C296.725 242.501 298.073 242.289 299.492 242.289C304.883 242.289 309.423 245.617 311.196 250.363H336.024C334.321 245.547 329.71 242.218 324.39 242.218Z",
    fill: "#7FCBFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M311.267 250.292C309.494 245.547 304.883 242.218 299.563 242.218C298.215 242.218 296.867 242.43 295.59 242.855C295.661 242.43 295.661 242.005 295.661 241.51C295.661 240.518 295.519 239.526 295.165 238.606C293.959 234.994 290.554 232.373 286.51 232.373C283.815 232.373 281.403 233.506 279.701 235.419C279.275 234.356 278.424 233.436 277.431 232.94C276.792 232.586 276.012 232.373 275.161 232.373C272.465 232.373 270.266 234.569 270.266 237.26C270.266 237.756 270.337 238.181 270.479 238.677C270.124 238.677 269.769 238.677 269.344 238.677C259.697 238.677 251.042 243.209 245.58 250.363H311.267V250.292Z",
    fill: "#2F3B49"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M396.674 207.089H393.624V232.019H396.674V207.089Z",
    fill: "#72B3FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M442.498 207.089H439.448V232.019H442.498V207.089Z",
    fill: "#72B3FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M454.699 231.948H381.423V239.102H454.699V231.948Z",
    fill: "#A7D0FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M398.731 239.102H391.637V250.221H398.731V239.102Z",
    fill: "#72B3FE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M444.556 239.102H437.462V250.221H444.556V239.102Z",
    fill: "#72B3FE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M452.571 213.534H383.551V218.633H452.571V213.534Z",
    fill: "#A7D0FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M452.571 206.168H383.551V211.268H452.571V206.168Z",
    fill: "#A7D0FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M452.571 221.042H383.551V225.858H452.571V221.042Z",
    fill: "#A7D0FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M181.738 207.089H178.688V232.019H181.738V207.089Z",
    fill: "#72B3FE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M227.562 207.089H224.512V232.019H227.562V207.089Z",
    fill: "#72B3FE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.795 239.102H176.701V250.221H183.795V239.102Z",
    fill: "#72B3FE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.619 239.102H222.526V250.221H229.619V239.102Z",
    fill: "#72B3FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M237.635 213.534H168.615V218.633H237.635V213.534Z",
    fill: "#A7D0FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M237.635 206.168H168.615V211.268H237.635V206.168Z",
    fill: "#A7D0FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M237.635 221.042H168.615V225.858H237.635V221.042Z",
    fill: "#A7D0FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.763 231.948H166.487V239.102H239.763V231.948Z",
    fill: "#A7D0FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278.069 18.3434L284.027 24.2926L290.341 17.9893L284.24 21.1055L278.069 18.3434Z",
    fill: "#2F3B49"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M241.182 39.6614L247.141 45.6106L253.454 39.2365L247.354 42.4235L241.182 39.6614Z",
    fill: "#2F3B49"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M201.458 9.91536L207.417 15.8646L213.73 9.49042L207.629 12.6775L201.458 9.91536Z",
    fill: "#2F3B49"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M576 249.583H0V251H576V249.583Z",
    fill: "#2F3B49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProject);
export default __webpack_public_path__ + "static/media/NoProject.e205cbd60d0b195cfa778b69d8b1c3cb.svg";
export { ForwardRef as ReactComponent };